import { EventResp } from 'types/event/events'
import { create } from 'zustand'

const eventDetails = (set: any) => ({
  eventDetailedData: null,
  setEventDetailedData: (state: EventResp) =>
    set(() => ({ eventDetailedData: state })),
})

export const eventDetailsStore = create(eventDetails)
